import { useState, useEffect } from 'react';

import { Item } from '@/types';

import { Company, useCompanies } from '@/features/companies';
import { useProperties } from '@/features/properties/api';
import { useItems } from '@/features/items/api';

type SelectEventType = React.ChangeEvent<HTMLSelectElement>;

/**
 * Page Controller for `ItemCatalogue`
 * @2025/05/16
 */
export const useItemCatalogueController = () => {
  const [activeTab, setActiveTab] = useState('table1');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [itemsAfterFilter, setitemsAfterFilter] = useState<Item[]>([]);

  const [filter, setFilter] = useState('ALL');

  const { data: items } = useItems();
  const propertiesQuery = useProperties();
  const { data: companies } = useCompanies();
  // ! include `active` and `new` company
  // @2025/05/29
  const companyFilter = (c: Company) => c.status == 'ACTIVE' || !c.status;
  const activeCompanies: Company[] | undefined =
    companies?.filter(companyFilter);

  // @2025/05/16
  const handlSelectChange = (event: SelectEventType) => {
    const filter = event.target.value;
    if (!items) return;
    setFilter(filter);
  };

  // ! observe the items change, it need time to update from backend!
  // ! @2025/0516
  useEffect(() => {
    if (!items) return;
    const result = items.filter((it) => {
      return filter == 'ALL' ? true : it?.classification_type == filter;
    });
    setitemsAfterFilter(result as Item[]);
  }, [items, filter]);

  return {
    activeTab,
    filter,
    isModalOpen,
    setActiveTab,
    setIsModalOpen,
    propertiesQuery,
    itemsAfterFilter,
    activeCompanies,
    handlSelectChange,
  };
};
